export function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  accentColor = 'soft-blue',
  trend,
}) {
  const iconColorMap = {
    'soft-blue': 'text-[#007aff]',
    'soft-indigo': 'text-[#5856d6]',
    'soft-emerald': 'text-[#34c759]',
    'soft-amber': 'text-[#ff9f0a]',
    'soft-purple': 'text-[#af52de]',
    'soft-teal': 'text-[#5ac8fa]',
    'soft-pink': 'text-[#ff2d55]',
  };

  const iconColor = iconColorMap[accentColor];

  return (
    <div
      className="bg-white/70 backdrop-blur-xl border border-white/60 rounded-[20px] p-6 hover:shadow-[0_20px_50px_rgb(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-1"
      style={{
        boxShadow: '0 8px 30px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.8)'
      }}
    >
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <p className="text-[11px] text-[#94A3B8] font-semibold tracking-widest uppercase">{title}</p>
          {Icon && (
            <Icon className={`w-6 h-6 ${iconColor}`} strokeWidth={2.5} />
          )}
        </div>

        <div className="flex items-baseline gap-2.5">
          <h3 className="text-[32px] font-bold tracking-tight text-[#0F172A] leading-none">{value}</h3>
          {trend && (
            <span
              className={`text-xs font-bold ${
                trend.isPositive ? 'text-[#34c759]' : 'text-[#ff3b30]'
              }`}
            >
              {trend.value}
            </span>
          )}
        </div>

        {subtitle && (
          <p className="text-[12px] text-[#94A3B8] font-normal">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
